const featureData = [
  {
    icon: 'ri-shield-check-line',
    title: '真实可靠',
    desc: '严格的内容审核机制，确保每一条资讯来源可追溯，为用户提供真实可信的八卦爆料平台。',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    icon: 'ri-group-line',
    title: '千万用户',
    desc: '汇聚全网最活跃的吃瓜群众，日均50万+活跃用户在线讨论，打造最具影响力的中文八卦社区。',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    icon: 'ri-speed-line',
    title: '极速更新',
    desc: '7x24小时全天候内容更新，重大事件发生后5分钟内即可在平台看到第一手爆料和讨论。',
    color: 'bg-secondary-100 text-secondary-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-accent-100">
            <i className="ri-medal-line text-accent-500 text-lg"></i>
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">平台优势</h2>
        </div>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10 pl-11 md:pl-12">为什么选择吃瓜网51？</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {featureData.map((item) => (
            <div
              key={item.title}
              className="flex flex-col items-center text-center p-8 md:p-10 rounded-2xl bg-background-50 border border-background-200/70"
            >
              <span className={`w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-2xl ${item.color} mb-5`}>
                <i className={`${item.icon} text-2xl md:text-3xl`}></i>
              </span>
              <h3 className="font-heading font-bold text-lg md:text-xl text-foreground-900 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed max-w-[300px]">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}